import Header from "./Header"; // Pastikan path ini sesuai dengan struktur proyekmu

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#C70039] via-[#F5F5F5] to-white text-gray-900 font-sans px-4">
      {/* 🧭 Header di bagian paling atas */}
      <div className="w-full max-w-[510px] mx-auto py-4">
          <Header
  
    />
      </div>

      {/* 📦 Konten utama halaman */}
      <div className="w-full max-w-[510px] mx-auto py-6">
        {children}
      </div>
    </div>
  );
}


